import {
  FETCH_SPECIALDAYS_SUCCESS,
  FETCH_SPECIALDAYS_ALL_SUCCESS,
  SET_SPECIALDAY_ID,
  ADD_SPECIALDAY,
  UPDATE_SPECIALDAY,
  DELETE_SPECIALDAY,
  FETCH_REMARKABLEDAYS_SUCCESS,
  SET_REMARKABLEDAY_ID,
  UPDATE_REMARKABLEDAY,
  FETCH_HOLIDAYS_SUCCESS,
  UPDATE_HOLIDAY,
  ADD_HOLIDAY,
  DELETE_HOLIDAY,
  CREATE_DAYTYPE,
  UPDATE_DAYTYPE,
  DELETE_DAYTYPE,
  SET_HOLIDAY_ID,
  SET_DAYTYPE_ID,
  SPECIALDAYS_FAILURE,
  SET_DISPLAYSETTING_ID,
  FETCH_DAYTYPES_SUCCESS,
} from "actions/types";

import { produce } from "immer";

const initialState = {
  SpecialDays: [],
  RemarkableDays: [],
  Holidays: [],
  DayTypes: [],
  displaySettingsId: -1,
  specialDayId: -1,
  remarkableDayId: -1,
  holidayId: -1,
  dayTypeId: -1,
  error: "",
};

const specialDaysReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    let key = 0;
    switch (action.type) {
      case FETCH_SPECIALDAYS_SUCCESS:
      case FETCH_SPECIALDAYS_ALL_SUCCESS:
        draft.SpecialDays = action.payload;
        draft.error = "";
        break;
      case SPECIALDAYS_FAILURE:
        draft.error = action.payload;
        break;
      case SET_SPECIALDAY_ID:
        draft.displaySettingsId = -1;
        draft.remarkableDayId = -1;
        draft.holidayId = -1;
        draft.dayTypeId = -1;
        draft.specialDayId = action.payload;
        break;
      case ADD_SPECIALDAY:
        if(action.payload.isSpecialDay){
          draft.SpecialDays = [...draft.SpecialDays, action.payload];
          draft.specialDayId = -1;
        } else {
          draft.RemarkableDays = [...draft.RemarkableDays, action.payload];
          draft.remarkableDayId = -1;          
        }
        break;
      case UPDATE_SPECIALDAY:
        key = draft.SpecialDays.findIndex((SD) => SD.id === action.payload.id);
        draft.SpecialDays[key] = action.payload;
        draft.specialDayId = -1;
        break;
      case DELETE_SPECIALDAY:
        key = draft.SpecialDays.findIndex((SD) => SD.id === action.payload.id);
        draft = { SpecialDays: draft.SpecialDays.splice(key, 1) };
        draft.specialDayId = -1;
        break;
      case FETCH_REMARKABLEDAYS_SUCCESS:
        draft.RemarkableDays = action.payload;
        break;
      case SET_REMARKABLEDAY_ID:
        draft.displaySettingsId = -1;
        draft.specialDayId = -1;
        draft.holidayId = -1;
        draft.dayTypeId = -1;
        draft.remarkableDayId = action.payload;
        break;
      case UPDATE_REMARKABLEDAY:
        key = draft.RemarkableDays.findIndex(
          (RD) => RD.id === action.payload.id
        );
        draft.RemarkableDays[key] = action.payload;
        draft.remarkableDayId = -1;
        break;
      case FETCH_HOLIDAYS_SUCCESS:
        draft.Holidays = action.payload;
        break;
      case SET_HOLIDAY_ID:
        draft.displaySettingsId = -1;
        draft.specialDayId = -1;
        draft.remarkableDayId = -1;
        draft.holidayId = action.payload;
        draft.dayTypeId = -1;
        break;
      case UPDATE_HOLIDAY:
        key = draft.Holidays.findIndex((HD) => HD.id === action.payload.id);
        draft.Holidays[key] = action.payload;
        draft.holidayId = -1;
        break;
      case ADD_HOLIDAY:
        draft.Holidays = [...draft.Holidays, action.payload];
        draft.holidayId = -1;
        break;
      case DELETE_HOLIDAY:
        key = draft.Holidays.findIndex((HD) => HD.id === action.payload.id);
        draft = { Holidays: draft.Holidays.splice(key, 1) };
        draft.holidayId = -1;
        break;
      case SET_DAYTYPE_ID:
        draft.displaySettingsId = -1;
        draft.specialDayId = -1;
        draft.remarkableDayId = -1;
        draft.holidayId = -1;
        draft.dayTypeId = action.payload;
        break;
      case CREATE_DAYTYPE:
        draft.DayTypes = [...draft.DayTypes, action.payload];
        draft.dayTypeId = -1;
        break;
      case UPDATE_DAYTYPE:
        key = draft.DayTypes.findIndex((HD) => HD.id === action.payload.id);
        draft.DayTypes[key] = action.payload;
        draft.dayTypeId = -1;
        break;
      case DELETE_DAYTYPE:
        key = draft.DayTypes.findIndex((HD) => HD.id === action.payload.id);
        draft = { DayTypes: draft.DayTypes.splice(key, 1) };
        draft.dayTypeId = -1;
        break;
      case SET_DISPLAYSETTING_ID:
        draft.displaySettingsId = action.payload;
        draft.specialDayId = -1;
        draft.remarkableDayId = -1;
        draft.holidayId = -1;
        break;
      case FETCH_DAYTYPES_SUCCESS:
        draft.DayTypes = action.payload
        break;
      default:
        return state;
    }
  });

export default specialDaysReducer;
